import React from 'react';
import styled, {css} from "styled-components";
import {GREY_4, PRIMARY, WHITE, LIGHT_PRIMARY} from "../../utils/colors";
import {useFlightSearchStore} from "../../store/flightSearch/flightSearchStore";
import type {Moment} from 'moment';
import {generateNextDates, previousValidTwoDays} from "../../utils/helpers";
import moment from 'moment';
type Props = {
    refetchSearch: () => void
    handleDateChange: (date: Moment) => void
}

const FlightDateFilter = ({ handleDateChange }: Props) => {
    const {
        formData: {
            DepartureDate
        }, updateFormData,
    } = useFlightSearchStore();

     const departureMoment = moment.isMoment(DepartureDate)
        ? DepartureDate
        : moment((DepartureDate as any)?.from || DepartureDate);

    const previousDates = previousValidTwoDays(departureMoment);
    const nextDates = generateNextDates(departureMoment, (4 - previousDates.length));

    return (
        <Container>
            <Wrapper>
                {
                    previousDates.map((date, key) => (
                        <Item onClick={() => handleDateChange(date)} key={key}>
                            {date.format('ddd, DD MMM')}
                        </Item>
                    ))
                }

                <Item active>
                    {departureMoment.format('ddd, DD MMM')}
                </Item>

                {
                    nextDates.map((date, index) => (
                        <Item onClick={() => handleDateChange(date)} key={index}>
                            {date.format('ddd, DD MMM')}
                        </Item>
                    ))
                }
            </Wrapper>
        </Container>
    );
};


export const Container = styled.div`
  width: 100%;
  background: ${WHITE};
  border-radius: 20px;
  padding: 10px;

  @media(max-width: 991px) {
    overflow-x:auto;
  }
`;

export const Wrapper = styled.div`
      display: flex;
      justify-content: space-between;
   
      @media(max-width: 991px) {
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap; 
        
        &::-webkit-scrollbar {
          display: none;
        }
      }
`;

export const Item = styled.div<{ active?: boolean}>`
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 8px;
  
   ${({ active }) => active && css`
     color: ${PRIMARY};
     cursor: default;
     background-color: ${LIGHT_PRIMARY};
   `};

    @media(max-width: 991px) {
      display: inline-block;
      margin-right: 30px;
    }
`;

export default FlightDateFilter;
